interface JsonPathInputProps {
  jsonPath: string | null;
  onJsonPathChange: (path: string) => void;
  disabled?: boolean;
}

const JsonPathInput = ({ jsonPath, onJsonPathChange, disabled = false }: JsonPathInputProps) => (
  <input
    id="json-path"
    className="w-full rounded border border-gray-300 px-2 py-1 disabled:cursor-not-allowed disabled:bg-gray-50"
    value={jsonPath || ""}
    onChange={e => onJsonPathChange(e.target.value)}
    disabled={disabled}
    placeholder="$.*"
  />
);

export default JsonPathInput;
